module.exports = __webpack_public_path__ + "static/KOLKATA-b5d70b1f6c19b7bdabc9ef50348f1c9f.png";